import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const EmploymentDistributionChart = () => {
  const [hiddenCategories, setHiddenCategories] = useState([]);

  const chartData = [
    { month: 'Jan', permanent: 234, contract: 156, casual: 89, temporary: 45 },
    { month: 'Feb', permanent: 238, contract: 162, casual: 92, temporary: 43 },
    { month: 'Mar', permanent: 242, contract: 158, casual: 95, temporary: 47 },
    { month: 'Apr', permanent: 245, contract: 165, casual: 88, temporary: 49 },
    { month: 'May', permanent: 248, contract: 170, casual: 91, temporary: 46 },
    { month: 'Jun', permanent: 251, contract: 168, casual: 94, temporary: 48 }
  ];

  const categories = [
    { key: 'permanent', label: 'Permanent', color: '#C41E3A' },
    { key: 'contract', label: 'Contract', color: '#FFD700' },
    { key: 'casual', label: 'Casual', color: '#059669' },
    { key: 'temporary', label: 'Temporary', color: '#4A5568' }
  ];

  const toggleCategory = (categoryKey) => {
    setHiddenCategories(prev =>
      prev?.includes(categoryKey)
        ? prev?.filter(k => k !== categoryKey)
        : [...prev, categoryKey]
    );
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4 md:mb-6 gap-2">
        <h3 className="font-heading text-base md:text-lg lg:text-xl font-semibold text-foreground break-words overflow-hidden">
          Employment Distribution Trends
        </h3>
        <Icon name="BarChart3" size={20} color="var(--color-primary)" className="flex-shrink-0 md:w-6 md:h-6" />
      </div>
      <div className="flex flex-wrap gap-2 md:gap-3 mb-4 md:mb-6">
        {categories?.map((category) => (
          <button
            key={category?.key}
            onClick={() => toggleCategory(category?.key)}
            className={`
              flex items-center gap-1.5 md:gap-2 px-2.5 md:px-3 py-1.5 md:py-2 rounded-md border transition-smooth text-xs md:text-sm
              ${hiddenCategories?.includes(category?.key)
                ? 'bg-muted text-muted-foreground border-border opacity-50'
                : 'bg-background text-foreground border-border hover:bg-muted'
              }
            `}
          >
            <div
              className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-sm flex-shrink-0"
              style={{ backgroundColor: category?.color }}
            />
            <span className="caption whitespace-nowrap">{category?.label}</span>
          </button>
        ))}
      </div>
      <div className="w-full flex-1 min-h-[280px] md:min-h-[320px] overflow-hidden" aria-label="Employment Distribution Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Legend />
            {categories?.map((category) => (
              !hiddenCategories?.includes(category?.key) && (
                <Bar
                  key={category?.key}
                  dataKey={category?.key}
                  fill={category?.color}
                  name={category?.label}
                />
              )
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EmploymentDistributionChart;